import Decimal from 'decimal.js'
import { submitEditWithdrawalProcessingMethod } from './model'
import { GatewayStatus } from 'src/pages/billing/paymentTrafficMonitoring/types'

export type OrderItem = {
  PropertyID: number
  PropertyName: string
  Amount: string
  Price: string
  TokenPrice: string
}

export type Order = {
  orderId: number
  transactionRequestId: number
  gatewayId: number
  status: string
  backendStatus: string
  amount: number
  orderItems: OrderItem[]
}

export type FormData = {
  amount: string
  address: string
  toBankAccountName: string
  toBankAccountNumber: string
}

export type WithdrawalEdit = {
  transactionId: string
  gatewayId: string
  clientId: string
  dealerApprovalStatus: string
  isAuto: boolean
  isCard: boolean
  processingProvider: string
  processingMethod: string
  status: string
  initialAmount: string
  initialAmountUsd: string
  initialCurrency: string
  clientAmount: string
  exchangeRate: string
  clientCurrency: string
  companyAmount: string
  companyCurrency: string
  clientCommission: string
  companyCommission: string
  commissionCurrency: string
  innerCommission: string
  createdAt: string
  updatedAt: string
  humanCreatedAt: string
  humanUpdatedAt: string
  client: Client
  changeHistory: Manager
  changeHistoryAll: ChangeHistoryEntry[]
  gateway: Gateway
  clientPurse: ClientPurse
  externalTransferId: string
  externalTransaction: ExternalTransaction
  externalPaymentTransaction: ExternalPaymentTransaction
  providerId: string
  psId: string
  clientPurseId: number
  destinationType: string
  rejectReason: string
  psComment: string
  managerComment: string
  internalComment: string
  destinationId: number
  order: Order
  mtTransactionId: number
  formData: FormData
  product?: string
  confirmedByManagerAt: string
  confirmedByVendorAt: string
  humanConfirmedByManagerAt: string
  humanConfirmedByVendorAt: string
  estimatedCommission: string
  withdrawalDecisions: WithdrawalDecisions
  formDataFieldSequenceOrder: {
    FieldDataType: number
    FieldName: string
    Value: string
    orderSequence: number
  }[]
}

type WithdrawalDecisions = {
  decisionID: number
  transactionRequestID: number
  status: number // общий статус
  startedAt: number
  endedAt: number
  approved: boolean
  checks: WithdrawalDecisionCheck[]
}

export type WithdrawalDecisionCheck = {
  decisionCheckID: number
  decisionID: number
  checkType: number // тип проверки
  status: number // статус отдельной проверки
  startedAt: number
  endedAt: number
  details?: string
  error?: string
}

export enum TransactionProduct {
  nova = 'nova',
  headway = 'headway',
}

export type Gateway = {
  gatewayId: number
  name: string
  internalName: string
  processingProvider: string
  paymentMethodType: string
  exchanger: Exchanger
  withdrawalGroupId: number
}

export type ProcessingMethod = {
  text: string
  value: number
}

export type Exchanger = {
  id: string
  frontName: string
  balance: string
}

export type Client = {
  clientId: string
  email: string
  fullName: string
  partner: boolean
  verified: boolean
  wallets: Wallet[]
  accounts: Account[]
  exchanger: Exchanger
  isTest: boolean
  isPremium: boolean
  country?: string
}

export type Wallet = {
  walletId: number
  balance: string
  currency: string
}

export type Account = {
  accountId: number
  balance: string
  availableToWithdraw: string
  currency: string
  isFixRate: boolean
  accountPlatform: string
  mtLogin: string
}

export type ClientPurse = {
  clientId: string
  id: number
  expiry: string
  isCard: boolean
  mask: string
  type: string
  verified: boolean
  status?: string
  clientName?: string
  bankName?: string
}

export type Manager = {
  id: string
  user: User
}

export type User = {
  email: string
  fullName: string
}

export type ChangeHistoryEntry = {
  id: number
  entityType: string
  entityId: number
  actionType: string
  actionDetails: string
  createdAt: string
  user: User
}

export type AmountType = {
  initialAmount: Decimal
  initialCurrency: string
  initialAmountVisited: boolean
  initialCurrencyVisited: boolean
  clientAmount: Decimal
  clientCurrency: string
  clientAmountVisited: boolean
  clientCurrencyVisited: boolean
}

export type UpdateAmount = {
  amount: AmountType
  withdrawal: WithdrawalEdit
}
export type UpdateProcessingMethod = {
  id: number
  gatewayId: number
}

export type WithdrawalStatus = {
  transactionId: string
  status: string
}

export type WithdrawalApproveRequest = {
  status: string
}

export type ExternalTransaction = {
  externalId: string
}

export type ExternalPaymentTransaction = {
  externalId: string
  externalStatus: string
  initialAmount: string
  initialCurrency: string
  paidAmount: string
  paidCurrency: string
  vendorCommission: string
  vendorCommissionCurrency: string
  extraData: string
}

export type ClientPurseResponse = {
  items: ClientPurse[]
  total: number
}

export type GatewayResponse = {
  items: Gateway[]
  total: number
}

export type DividendBalance = {
  id: number
  balance: string
  currency: string
}

export const dividendBalanceDefault: DividendBalance = {
  id: 0,
  balance: '0',
  currency: 'USD',
}

export type DisableAutoWithdrawalParams = {
  transactionId: string
}

export type ApiError = {
  message?: string
}

export type RequestState = {
  loading: boolean
  success: boolean
  error: string
}

export type GatewayCountries = Record<string, GatewayStatus | null>

export type GatewaysStatusResponse = {
  gateways: Record<string, GatewayCountries>
}
